import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import type { FC } from 'react';
import React from 'react';

import { toggleLeftNavCollapsed, useIsLeftNavCollapsed } from '../store';

import CollapseIconButton from './CollapseIconButton';

const collapsedToggleHeight = 36;
const expandedToggleHeight = 32;

const NavCollapseToggle: FC = () => {
  'use memo';

  const t = useTranslations(NavigationStrings);
  const isCollapsed = useIsLeftNavCollapsed();

  const ariaLabel = isCollapsed ? t.appNavigationExpandButtonAriaLabel() : t.appNavigationCollapseButtonAriaLabel();

  return (
    <CollapseIconButton
      ariaLabel={ariaLabel}
      ariaExpanded={!isCollapsed}
      height={isCollapsed ? collapsedToggleHeight : expandedToggleHeight}
      onClick={toggleLeftNavCollapsed}
    />
  );
};

export default NavCollapseToggle;
